import { forwardRef } from "react";
import Text from "../text";
import { jsx as _jsx } from "react/jsx-runtime";
export const Heading = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    level = 1,
    ...rest
  } = _ref;
  return /*#__PURE__*/_jsx(Text, {
    ref: ref,
    as: `h${level}`,
    fontSize: Math.max(0, 7 - level),
    ...rest
  });
});
Heading.defaultProps = {
  color: "heading",
  lineHeight: "heading",
  fontFamily: "secondary"
};
export default Heading;